import clientConfig from '../../../../../../client-config';
const ProgramsUrl = clientConfig.ProgramsUrl;
const FullPath = `${ProgramsUrl}/progrmas/PLAY_MACHINES_1/BuildingInstructions_Images/ExplorationModels`

const Pic1 = `${FullPath}/MechanicalCam/1_1x.png`;
const Pic2 = `${FullPath}/MechanicalCam/2_1x.png`;
const Pic3 = `${FullPath}/MechanicalCam/3_1x.png`;
const Pic4 = `${FullPath}/MechanicalCam/4_1x.png`;
const Pic5 = `${FullPath}/MechanicalCam/5_1x.png`;
const Pic6 = `${FullPath}/MechanicalCam/6_1x.png`;
const Pic7 = `${FullPath}/MechanicalCam/7_1x.png`;
const Pic8 = `${FullPath}/MechanicalCam/8_1x.png`;
const Pic9 = `${FullPath}/MechanicalCam/9_1x.png`;
const Pic10 = `${FullPath}/MechanicalCam/10_1x.png`;
const Pic11 = `${FullPath}/MechanicalCam/11_1x.png`;
const Pic12 = `${FullPath}/MechanicalCam/12_1x.png`;
const Pic13 = `${FullPath}/MechanicalCam/13_1x.png`;
const Pic14 = `${FullPath}/MechanicalCam/14_1x.png`;
const Pic15 = `${FullPath}/MechanicalCam/15_1x.png`;
const Pic16 = `${FullPath}/MechanicalCam/16_1x.png`;
const Pic17 = `${FullPath}/MechanicalCam/17_1x.png`;



export const Buildingimages = [

]
    const Pics = [
        Pic1,
        Pic2,
        Pic3,
        Pic4,
        Pic5,
        Pic6,
        Pic7,
        Pic8,
        Pic9,
        Pic10,
        Pic11,
        Pic12,
        Pic13,
        Pic14,
        Pic15,
        Pic16,
        Pic17,
    ]


    for (let i = 0; i < Pics.length; i++) {
        let obj = {};
        obj['original'] = Pics[i];
        obj['thumbnail'] = Pics[i];
        Buildingimages.push(obj);
    }

export default {
    Buildingimages,
}